import { SocketData } from "reducers/webSocketMessageReducer";

import {
  INITIAL_MESSAGE,
  REMOVE_TASK_MESSAGE,
  UPDATE_TASK_MESSAGE,
} from "./constants";

export const InitializeMessage = (data: SocketData) => {
  return {
    type: INITIAL_MESSAGE,
    payload: data,
  };
};

export const UpdateTaskMessage = (data: SocketData) => {
  return {
    type: UPDATE_TASK_MESSAGE,
    payload: data,
  };
};

export const RemoveTaskMessage = (task_id: string) => {
  return {
    type: REMOVE_TASK_MESSAGE,
    payload: task_id,
  };
};
